import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const Section = styled.div`
  margin-top: 15px;
  padding-bottom: 15px;
  text-align: center;
  border-bottom: 1px solid ${theme.colors.grey600};
`
